const propStateMapping = {
    keyphrase: (request, state) => state.keyphrase && request.setSearchQueryKeyphrase(state.keyphrase),
    suggestionsList: (request, state) => state.suggestionsList &&
        request.setSearchSuggestion(state.suggestionsList.map(({ suggestion, max = 3 }) => ({ name: suggestion, max }))),
    itemsPerPage: (request, state) => request.setSearchLimit(state.itemsPerPage),
};
export default propStateMapping;
